import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IBaselinePayload, IInitialStateBaseline } from "../types";
import { GetBaseline, GetDeleteBaseline } from "../store/thunk";

const initialState: IInitialStateBaseline = {
    baseline: [],
    baselineRestore: [],
    isLoadingBaseline: false,
    isViewBaselineRestore: false,
    selectedBaselineIDs: [],
    baselineBlocks: {
        educational_units: [],
        max_course_number: 0,
        reference_blocks_grouped: [],
        reference_data_id: 0,
    },
};

const baselineSlice = createSlice({
    initialState,
    name: "baseline",
    reducers: {
        setBaseline: (state, action: PayloadAction<IBaselinePayload[]>) => {
            state.baseline = action.payload;
        },
        deletedBaseline: (state, action: PayloadAction<number>) => {
            state.baseline = state.baseline.filter(elem => elem.id !== action.payload);
        },
        setBaselineBlocks: (state, action) => {
            state.baselineBlocks = action.payload;
        },

        updateBaseline: (state, action: PayloadAction<IBaselinePayload>) => {
            state.baseline = state.baseline.map(elem =>
                elem.id === action.payload.id ? { ...elem, ...action.payload } : elem
            );
        },
        setRestoreBaseline: (state, action) => {
            state.baselineRestore = action.payload;
        },
        deletedRestoreBaseline: (state, action) => {
            state.baselineRestore = state.baselineRestore.filter(elem => elem.id !== action.payload);
        },
        setIsViewRestoreBaseline: state => {
            state.isViewBaselineRestore = !state.isViewBaselineRestore;
        },
        setSelectedBaselineIDs: (state, action) => {
            state.selectedBaselineIDs = action.payload;
        },
    },
    extraReducers: builder => {
        builder
            .addCase(GetBaseline.pending, state => {
                state.isLoadingBaseline = true;
            })
            .addCase(GetBaseline.fulfilled, state => {
                state.isLoadingBaseline = false;
            })
            .addCase(GetBaseline.rejected, state => {
                state.isLoadingBaseline = false;
            })
            .addCase(GetDeleteBaseline.pending, state => {
                state.isLoadingBaseline = true;
            })
            .addCase(GetDeleteBaseline.fulfilled, state => {
                state.isLoadingBaseline = false;
            })
            .addCase(GetDeleteBaseline.rejected, state => {
                state.isLoadingBaseline = false;
            });
    },
});

export const {
    setBaseline,
    deletedBaseline,
    updateBaseline,
    setRestoreBaseline,
    deletedRestoreBaseline,
    setIsViewRestoreBaseline,
    setSelectedBaselineIDs,
    setBaselineBlocks,
} = baselineSlice.actions;

export default baselineSlice;
